import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-content-container',
  templateUrl: './content-container.component.html',
  styleUrls: ['./content-container.component.scss'],
})
export class ContentContainerComponent {
  @Input() standardPaddingTop: boolean;
  @Input() fullPageHeight: boolean;
}
